import React, {Component} from 'react';
import {connect} from 'react-redux';
import Svg from '../svg/index';
import {Theme} from '../theme/index';
import {_Object} from "../utils/utils";

const styleFn = (type, _this) => {

    return {
        buttonBox: {
            width: _this.props.width || "5.25rem",
            height: _this.props.height || "2.125rem",
            background: type.bg_color,
            border: `0.08rem solid ${type.border_color}`,
            color: type.text_color,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: type.font_size,
            borderRadius: "0.1875rem",
            cursor: "pointer",
        },
        buttonSvg: {
            // marginLeft: "1rem",
            marginRight: "0.625rem"
        },
        buttonText: {},
    }
};


//公用获取主题的方法
let getTheme = (_this) => {
    // designationTheme  指定的主题，  theme  redux设置的全局主题,
    let themeName = _this.props.designationTheme || _this.props.theme || "default";
    let _theme = _this.state.theme[themeName].button.type;
    if (!_theme) {
        _theme = _this.state.theme["default"].button.type;
    }
    return _theme
};

class ButtonBox extends Theme {
    constructor(props) {
        super(props);
        let _state = {};
        this.state = _Object.merge(this.state || {}, _state)
    };

    render() {
        let _theme = getTheme(this);
        let type = _theme[this.props.scenesType || "submit"];
        let styles = _Object.merge({}, styleFn(type, this));
        return (
            <div style={styles.buttonBox} onClick={this.props.handleBtn}>
                {(this.props.svgName || type.svg_name) &&
                <Svg type={this.props.svgName || type.svg_name}
                     fill={type.svg_color}
                     width="1rem"
                     height="1rem"
                     style={styles.buttonSvg}/>
                }
                <div style={styles.buttonText}>{this.props.btnText || type.btn_text}</div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        theme: state.theme,
    }
};

const mapDispatchToProps = dispatch => ({});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ButtonBox)